"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUserSessionState = void 0;
var _useUserSessionStatus = require("./useUserSessionStatus");
var _react = require("react");
var _constants = require("../../utils/constants");
var _userSelectors = require("../../store/user/userSelectors");
var _userActions = require("../../store/user/userActions");
var _useConfig = _interopRequireDefault(require("../useConfig"));
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useUserSessionState = () => {
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const {
    userSessionJourneyStatus,
    isUserSessionLoaded
  } = (0, _useUserSessionStatus.useUserSessionStatus)();
  const bufferSessionCreation = (0, _useConfig.default)('settings.bufferSessionCreation');
  const marketingId = (0, _useAppSelector.useAppSelector)(_userSelectors.selectMarketingId);
  const userSession = (0, _useAppSelector.useAppSelector)(_userSelectors.selectUserSession);
  (0, _react.useEffect)(() => {
    var _userSession$processF;
    if (!isUserSessionLoaded) {
      return;
    }
    if (userSessionJourneyStatus === _constants.USER_SESSION_JOURNEY_STATUS.NEW_USER) {
      if (!bufferSessionCreation) dispatch((0, _userActions.createUserSession)(marketingId));
      return;
    }
    const sessionState = (_userSession$processF = userSession.processFlow.characteristic.find(item => item.name === 'stateMetadata')) === null || _userSession$processF === void 0 ? void 0 : _userSession$processF.value;
    if (sessionState) {
      const parsedSessionState = JSON.parse(sessionState);
      dispatch((0, _userActions.resumeUserSession)(parsedSessionState));
    }
  }, [isUserSessionLoaded]);
};
exports.useUserSessionState = useUserSessionState;